// https://js.devexpress.com/Demos/WidgetsGallery/Demo/Form/Validation/React/Light/
import React, { useState } from 'react';
import notify from "devextreme/ui/notify";


import Form, {
    SimpleItem,
    GroupItem,
    Label,
    ButtonItem,
} from 'devextreme-react/form';
import { useAuthStore } from '../hooks/useAuthStore';
import ErrorLine from './ErrorLine';

const Login = () => {
    const authStore = useAuthStore();

    const defParams = { login: "", password: "", remember: true };
    const [params, setParams] = useState(defParams);
    const [errorText, setErrorText] = useState("");
    const buttonOptions = {
        text: "Войти",
        type: "success",
        onClick: async (e) => {
//            alert(JSON.stringify(params));
            try {
                await authStore.login(params.login, params.password);
            }
            catch (e) {
//                notify(e, "error");
                setErrorText(e.message);
            }
        }
    };
    const onEditorEnterKey = (e) => {
        authStore.login(params.login, params.password);
    }
    const passwordOptions = {
        mode: "password"
    }
    const checkBoxOptions = {
        text: '',
//        value: false,
    };

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <Form
                formData={params}
                onEditorEnterKey={onEditorEnterKey}
            >
            <GroupItem cssClass="first-group_" colCount={4}>
                <GroupItem colSpan={2}>
                    <SimpleItem dataField="login">
                        <Label
                            text="Логин"
                            location="left"
                            alignment="right"
                        >
                        </Label>
                    </SimpleItem>
                    <SimpleItem dataField="password" editorOptions={passwordOptions}>
                        <Label
                            text="Пароль"
                            location="left"
                            alignment="right"
                        >
                        </Label>
                    </SimpleItem>
                    <SimpleItem dataField="remember"
                        editorType="dxCheckBox"
                        editorOptions={checkBoxOptions}>
                            <Label
                                visible={true}
                                text="Запомнить"
                                location="left"
                                alignment="right"
                            />
                    </SimpleItem>
                    <ButtonItem
                        horizontalAlignment="left"
                        buttonOptions={buttonOptions}
                    />

                </GroupItem>
            </GroupItem>
            </Form>
            <ErrorLine
                errorText={errorText}
                type="error"
            />
        </div>
    );
}

function avatarRender() {
    return (
        <div className="form-avatar_"></div>
    );
}
export default React.memo(Login);
